import CloseIcon from '@mui/icons-material/Close';

import { IconButton, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  handleCloseModal: () => void;
  isEditMode?: boolean;
}

export const ModalHeader: React.FC<IProps> = ({ handleCloseModal, isEditMode = false }) => {
  return (
    <>
      <Typography variant="h6" sx={{ lineHeight: 1.4 }}>
        {isEditMode ? 'Template defaults' : 'Template setup'}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {isEditMode
          ? 'Changes here set the defaults for all pages. Page overrides remain unchanged.'
          : 'Name your template and set defaults that apply to all pages. You can change these later.'}
      </Typography>
      <IconButton
        onClick={handleCloseModal}
        aria-label="close"
        sx={{ position: 'absolute', right: 16, top: 16 }}
        data-action="close_btn"
      >
        <CloseIcon />
      </IconButton>
    </>
  );
};
